<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.filters.title") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="py-0">
        <v-layout row wrap>
          <v-flex md12>
            <filters ref="filters" @filter="filter" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="clave"
              class="bitacora dataTable"
              sort-by="fecha"
              show-expand
              :sort-desc="true"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :single-expand="false"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options"
              :expanded.sync="expanded">
              <template #top>
                <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
              </template>
              <template #item.fecha="{ item }">
                {{ formatDateTime(item.fecha) }}
              </template>
              <template #expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <strong>{{ $t("view.bitacoras.bitacora.form.url.th") }}: </strong> {{ item.url }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>
<script>
import BitacoraAPI from "@/services/bitacoras/bitacora"; /** *******************************/
import Filters from "@/views/bitacoras/bitacora/Filters"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import { formatDateTime } from "@/helpers/date-methods";

export default {
  components: { Filters }
  , data() {
    return {
      options: {}
      , expanded: []
      , filtros: {}
      , search: ""
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.bitacoras.bitacora.form.fecha.th"), align: "center", sortable: true, class: "fecha", cellClass: "fecha", value: "fecha" }
              , { text: this.$t("view.bitacoras.bitacora.form.modulo.th"), align: "center", sortable: true, class: "modulo", cellClass: "modulo", value: "modulo" }
              , { text: this.$t("view.bitacoras.bitacora.form.addres.th"), align: "center", sortable: true, class: "addres", cellClass: "addres", value: "addres" }
              , { text: this.$t("view.commons.usuario"), align: "center", sortable: true, class: "usuario", cellClass: "usuario", value: "usuario" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: true, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await BitacoraAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;
      this.options.page = 1;
      this.load();
    }
    , formatDateTime
  }
};
</script>

<style>
.bitacora .fecha {
  padding-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bitacoras/bitacora/DataTable.vue